// import EmptyDashboard from './Components/empty-dashboard';
import BuilderDashBoard from './Containers/builder-dashboard';
// import {AppSettings} from '../constants';

export default [
  {
    path: '/report-dashboards',
    component: BuilderDashBoard,
    private: true,
    menu: {
      name: 'Dashboards',
      group: 'Report',
      icons: 'pe-7s-monitor',
      order: 1
    }
  }
];



// WEBPACK FOOTER //
// ./src/Dashboard/routes.js